import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface Comment {
  comment: string;
  creationDate: string;
  creationPpo: string;
}

export interface GetCommentsResponse {
  rgName: string;
  receivingPpo: string;
  sendingPpo: string;
  year: number;
  quarter: number;
  remunerationGroupCommentDtos: Comment[];
}

export function useGetComments(senderId: number | null) {
  return useQuery<GetCommentsResponse, Error>({
    queryKey: ['comments', senderId],
    queryFn: async () => {
      console.log('Fetching comments for senderId:', senderId);
      const response = await axios.get(`/rg/comment/${senderId}`);
      console.log('Comments response:', response.data);
      return response.data;
    },
    staleTime: 0, // Always refetch
  });
}
